import { PrintCardMenu } from './print-card-menu';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { AssetLibraryType } from '../../enum/dto/asset-library-type.enum';

export class FikaConcentratePrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [
      FONT.NeueHaasGroteskDisplay.Regular_400,
      FONT.NeueHaasGroteskDisplay.Medium_500,
      FONT.NeueHaasGroteskDisplay.SemiBold_600,
      FONT.NeueHaasGroteskDisplay.Bold_700
    ];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/wxq6frp.css';
  }

  shouldStandardizeDominantStrainType(): boolean {
    return false;
  }

  shouldFetchVariantAssets(): boolean {
    return true;
  }

  override variantAssetTypeSortOrder(): string[] {
    return [AssetLibraryType.PrimaryBrand, AssetLibraryType.AlternateBrand, AssetLibraryType.Brand];
  }
}
